/**
 * Format a number using a thousands separator.
 * @param {number|string} value - The value to format.
 * @param {object} options - Optional formatting options.
 * @param {string} [options.locale='fr-FR'] - Locale used for formatting.
 * @param {number} [options.decimals] - Force a specific number of decimals.
 * @param {string} [options.fallback=''] - Returned when value is not a finite number.
 * @returns {string} Formatted number with thousands separators.
 */
export const formatWithThousandSeparator = (value, options = {}) => {
 
  const { locale = 'fr-FR', decimals, fallback = '' } = options;

  if (value === null || value === undefined || value === '') {
    return fallback;
  }

  const numericValue = Number(
    typeof value === 'string' ? value.toString().replace(/\s+/g, '').replace(',', '.') : value
  );

  if (!Number.isFinite(numericValue)) {
    return fallback;
  }

  const formatter = new Intl.NumberFormat(locale, {
    minimumFractionDigits: typeof decimals === 'number' ? decimals : undefined,
    maximumFractionDigits: typeof decimals === 'number' ? decimals : undefined,
  });

  return formatter.format(numericValue);
};

export default formatWithThousandSeparator;
